'use client'

import { createContext, useContext, useState, useEffect } from 'react'
import { usePathname, useRouter } from 'next/navigation'

const LanguageContext = createContext()

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState('en')
    const [isInitialized, setIsInitialized] = useState(false)
    const [isChangingLanguage, setIsChangingLanguage] = useState(false)
    const router = useRouter()
    const pathname = usePathname()

    useEffect(() => {
        // Определяем язык из URL (теперь всегда первый сегмент)
        if (pathname) {
            const pathParts = pathname.split('/')
            const urlLang = pathParts[1]

            if (urlLang === 'ru' || urlLang === 'en') {
                setLanguage(urlLang)
                // Сохраняем выбранный язык в cookie для последующих посещений
                if (typeof document !== 'undefined') {
                    document.cookie = `preferred-language=${urlLang}; path=/; max-age=31536000; SameSite=Lax; Secure`
                }
            } else {
                // язык не распознан – оставляем по умолчанию
            }
            setIsInitialized(true)
        }
    }, [pathname])

    const toggleLanguage = () => {
        if (!pathname || !isInitialized || isChangingLanguage) {
            return
        }

        const newLanguage = language === 'ru' ? 'en' : 'ru'
        const pathParts = pathname.split('/')

        if (pathParts.length > 1 && (pathParts[1] === 'ru' || pathParts[1] === 'en')) {
            pathParts[1] = newLanguage
            const newPath = pathParts.join('/')

            // Устанавливаем флаг смены языка для предотвращения двойных кликов
            setIsChangingLanguage(true)
            setLanguage(newLanguage)

            // Сохраняем выбранный язык в cookie для последующих посещений
            if (typeof document !== 'undefined') {
                document.cookie = `preferred-language=${newLanguage}; path=/; max-age=31536000; SameSite=Lax; Secure`
            }

            // Используем window.location.href для принудительной перезагрузки страницы
            // Это гарантирует, что все компоненты будут перерендерены с новым языком
            if (typeof window !== 'undefined') {
                window.location.href = newPath
            } else {
                router.push(newPath)
            }
        } else {
            // Нераспознанный формат пути
        }
    }

    // Всегда рендерим одинаково, используя язык по умолчанию до инициализации
    const currentLanguage = isInitialized ? language : 'en'

    return (
        <LanguageContext.Provider value={{ language: currentLanguage, toggleLanguage, isChangingLanguage }}>
            {children}
        </LanguageContext.Provider>
    )
}

export function useLanguage() {
    const context = useContext(LanguageContext)
    if (context === undefined) {
        throw new Error('useLanguage must be used within a LanguageProvider')
    }
    return context
} 